import { request } from '../utils/request';

export const fetchList = params =>
  request.get('/admin/manual-messaging', { params });

export const createRestartJob = params => request.post('/restart-job', params);
